export const translations = {
  es: {
    nav: {
      services: "Servicios",
      about: "Nosotros",
      pricing: "Tarifas",
      team: "Equipo",
      gallery: "Taller",
      contact: "Contacto",
      whatsapp: "WhatsApp",
    },
    hero: {
      overline: "Taller multimarca · Parets del Vallès",
      title_1: "Mecánica",
      title_2: "Preparación",
      title_3: "Confianza",
      subtitle:
        "Diagnosis avanzada, reparaciones complejas y mantenimiento profesional para cualquier vehículo. Más de 5 años cuidando del motor de nuestros clientes.",
      cta_primary: "Escríbenos por WhatsApp",
      cta_secondary: "Ver servicios",
      scroll: "Desplaza",
    },
    services: {
      overline: "Lo que hacemos",
      title: "Servicios completos para tu vehículo",
      subtitle:
        "Cuatro áreas de especialización para cubrir cada necesidad mecánica, electrónica y estética de tu coche.",
      items: [
        {
          name: "Mecánica General",
          desc: "Reparaciones para vehículos gasolina, diésel e híbridos.",
          features: [
            "Revisiones completas",
            "Cambio de aceite y filtros",
            "Distribuciones",
            "Embragues",
            "Frenos y suspensión",
            "Sistemas de refrigeración",
            "Reparaciones de motor",
          ],
        },
        {
          name: "Diagnosis Electrónica",
          desc: "Equipos profesionales para detectar averías con precisión.",
          features: [
            "Lectura y borrado de fallos",
            "Diagnosis multimarca",
            "Centralitas y sensores",
            "Localización exacta del problema",
            "Ahorro de tiempo y dinero",
          ],
        },
        {
          name: "Neumáticos y Alineación",
          desc: "Servicio integral de neumáticos multimarca.",
          features: [
            "Montaje y desmontaje",
            "Equilibrado",
            "Reparación de pinchazos",
            "Alineación de dirección",
            "Sustitución de válvulas",
          ],
        },
        {
          name: "Preparación y Optimización",
          desc: "Proyectos personalizados para entusiastas.",
          features: [
            "Mejoras mecánicas",
            "Instalaciones especiales",
            "Preparaciones estéticas",
            "Ajustes personalizados",
            "Asesoramiento técnico",
          ],
        },
      ],
    },
    about: {
      overline: "Filosofía T-CARS",
      title: "Un taller serio. Una atención cercana.",
      paragraph_1:
        "En T-CARS GARAGE 2019 S.L. trabajamos con una filosofía clara: ofrecer un servicio profesional, transparente y de máxima calidad para cualquier tipo de vehículo.",
      paragraph_2:
        "Combinamos experiencia mecánica, tecnología de diagnosis avanzada y un trato directo para que cada cliente salga del taller con total confianza. Somos un referente en Parets del Vallès para conductores que buscan rapidez y profesionalidad.",
      stats: [
        { value: "5+", label: "Años de actividad" },
        { value: "100%", label: "Multimarca" },
        { value: "1:1", label: "Atención personalizada" },
      ],
    },
    why: {
      overline: "Por qué elegirnos",
      title: "Cuatro razones para confiar en nosotros",
      items: [
        {
          title: "Atención personalizada",
          desc: "Cada vehículo recibe un diagnóstico individual y un trato totalmente personalizado.",
        },
        {
          title: "Transparencia total",
          desc: "Explicamos cada reparación con claridad y sin costes ocultos. Tú decides.",
        },
        {
          title: "Calidad profesional",
          desc: "Recambios de calidad y herramientas profesionales en todos los trabajos.",
        },
        {
          title: "Rapidez y eficacia",
          desc: "Optimizamos cada reparación para reducir tu tiempo de espera al mínimo.",
        },
      ],
    },
    pricing: {
      overline: "Tarifas orientativas",
      title: "Precios claros, sin sorpresas",
      subtitle:
        "Estas tarifas son orientativas. Te facilitamos un presupuesto exacto sin compromiso tras revisar tu vehículo.",
      note: "* Precios sin IVA. Solicita presupuesto personalizado.",
      items: [
        { name: "Cambio de aceite y filtros", price: "Desde 65 €" },
        { name: "Revisión pre-ITV", price: "Desde 45 €" },
        { name: "Diagnosis electrónica", price: "Desde 35 €" },
        { name: "Pastillas de freno (delantero)", price: "Desde 90 €" },
        { name: "Distribución completa", price: "Desde 350 €" },
        { name: "Embrague", price: "Desde 480 €" },
        { name: "Alineación de dirección", price: "Desde 45 €" },
        { name: "Equilibrado de ruedas (x4)", price: "Desde 30 €" },
        { name: "Montaje de neumático", price: "Desde 12 €/ud" },
        { name: "Hora de taller", price: "45 €" },
      ],
      cta: "Pedir presupuesto",
    },
    team: {
      overline: "Nuestro equipo",
      title: "Profesionales apasionados por la automoción",
      subtitle:
        "Un equipo comprometido con ofrecer el mejor servicio posible, desde la primera llamada hasta la entrega de tu vehículo.",
      members: [
        {
          name: "Moisés Loira",
          role: "Mecánico y Preparador",
          bio: "Especialista en mecánica multimarca, diagnosis electrónica y proyectos de preparación.",
        },
        {
          name: "Aitor Loira",
          role: "Administrador",
          bio: "Responsable de la gestión, planificación y atención al cliente. Tu primer contacto con el taller.",
        },
      ],
    },
    gallery: {
      overline: "Instalaciones",
      title: "Nuestro taller",
      subtitle:
        "Instalaciones modernas y equipamiento actualizado, preparado para vehículos modernos y sistemas electrónicos de última generación.",
    },
    contact: {
      overline: "Visítanos",
      title: "Hablemos sobre tu vehículo",
      subtitle:
        "Estamos en Parets del Vallès. Llámanos, escríbenos por WhatsApp o acércate al taller.",
      address_label: "Dirección",
      address: "Cami de Can Guasch, 5, Nave 3\n08150 Parets del Vallès, Barcelona",
      phone_label: "Teléfono",
      hours_label: "Horario",
      hours_weekdays: "Lunes a Viernes",
      hours_weekend: "Sábados y Domingos",
      hours_closed: "Cerrado",
      cta_whatsapp: "Chatear por WhatsApp",
      cta_call: "Llamar ahora",
      cta_directions: "Cómo llegar",
    },
    footer: {
      tagline: "Mecánica · Preparación · Diagnosis",
      company_label: "Razón social",
      activity_label: "Actividad",
      activity: "Mantenimiento y reparación de vehículos de motor",
      rights: "Todos los derechos reservados.",
    },
  },
  en: {
    nav: {
      services: "Services",
      about: "About",
      pricing: "Pricing",
      team: "Team",
      gallery: "Workshop",
      contact: "Contact",
      whatsapp: "WhatsApp",
    },
    hero: {
      overline: "Multibrand workshop · Parets del Vallès",
      title_1: "Mechanics",
      title_2: "Tuning",
      title_3: "Trust",
      subtitle:
        "Advanced diagnostics, complex repairs and professional maintenance for any vehicle. Over 5 years caring for our customers' engines.",
      cta_primary: "Message us on WhatsApp",
      cta_secondary: "See services",
      scroll: "Scroll",
    },
    services: {
      overline: "What we do",
      title: "Complete services for your vehicle",
      subtitle:
        "Four areas of expertise to cover every mechanical, electronic and aesthetic need of your car.",
      items: [
        {
          name: "General Mechanics",
          desc: "Repairs for petrol, diesel and hybrid vehicles.",
          features: [
            "Full inspections",
            "Oil & filter changes",
            "Timing belts",
            "Clutches",
            "Brakes & suspension",
            "Cooling systems",
            "Engine repairs",
          ],
        },
        {
          name: "Electronic Diagnosis",
          desc: "Professional equipment to detect faults precisely.",
          features: [
            "Fault reading & clearing",
            "Multibrand diagnosis",
            "ECUs and sensors",
            "Exact problem location",
            "Save time and money",
          ],
        },
        {
          name: "Tyres & Alignment",
          desc: "Complete multibrand tyre service.",
          features: [
            "Mounting & dismounting",
            "Balancing",
            "Puncture repairs",
            "Wheel alignment",
            "Valve replacement",
          ],
        },
        {
          name: "Tuning & Optimisation",
          desc: "Custom projects for enthusiasts.",
          features: [
            "Mechanical upgrades",
            "Special installations",
            "Aesthetic prep",
            "Custom adjustments",
            "Technical advice",
          ],
        },
      ],
    },
    about: {
      overline: "T-CARS Philosophy",
      title: "Serious workshop. Honest service.",
      paragraph_1:
        "At T-CARS GARAGE 2019 S.L. we work with a clear philosophy: deliver a professional, transparent and top-quality service for every type of vehicle.",
      paragraph_2:
        "We combine mechanical experience, advanced diagnostic technology and direct customer service so that every driver leaves with complete confidence. We're a reference in Parets del Vallès for drivers who value speed and professionalism.",
      stats: [
        { value: "5+", label: "Years in business" },
        { value: "100%", label: "Multibrand" },
        { value: "1:1", label: "Personal attention" },
      ],
    },
    why: {
      overline: "Why choose us",
      title: "Four reasons to trust us",
      items: [
        {
          title: "Personal attention",
          desc: "Every vehicle gets an individual diagnosis and personalised treatment.",
        },
        {
          title: "Full transparency",
          desc: "We explain every repair clearly and without hidden costs. You decide.",
        },
        {
          title: "Professional quality",
          desc: "Quality parts and professional tools on every job.",
        },
        {
          title: "Fast and effective",
          desc: "We optimise every repair to keep your waiting time to a minimum.",
        },
      ],
    },
    pricing: {
      overline: "Indicative pricing",
      title: "Clear pricing, no surprises",
      subtitle:
        "These prices are indicative. We provide a precise no-obligation quote after inspecting your vehicle.",
      note: "* Prices excl. VAT. Request a custom quote.",
      items: [
        { name: "Oil & filter change", price: "From €65" },
        { name: "Pre-MOT inspection", price: "From €45" },
        { name: "Electronic diagnosis", price: "From €35" },
        { name: "Front brake pads", price: "From €90" },
        { name: "Full timing belt service", price: "From €350" },
        { name: "Clutch replacement", price: "From €480" },
        { name: "Wheel alignment", price: "From €45" },
        { name: "Wheel balancing (x4)", price: "From €30" },
        { name: "Tyre mounting", price: "From €12/u" },
        { name: "Workshop hour", price: "€45" },
      ],
      cta: "Request a quote",
    },
    team: {
      overline: "Our team",
      title: "Professionals passionate about cars",
      subtitle:
        "A team committed to delivering the best possible service, from the first call to the moment we hand back your vehicle.",
      members: [
        {
          name: "Moisés Loira",
          role: "Mechanic & Tuner",
          bio: "Specialist in multibrand mechanics, electronic diagnosis and tuning projects.",
        },
        {
          name: "Aitor Loira",
          role: "Manager",
          bio: "In charge of operations, scheduling and customer care. Your first point of contact.",
        },
      ],
    },
    gallery: {
      overline: "Facilities",
      title: "Our workshop",
      subtitle:
        "Modern facilities and up-to-date equipment, ready for modern vehicles and the latest electronic systems.",
    },
    contact: {
      overline: "Visit us",
      title: "Let's talk about your vehicle",
      subtitle:
        "We're in Parets del Vallès. Call us, send a WhatsApp message or drop by the workshop.",
      address_label: "Address",
      address: "Cami de Can Guasch, 5, Nave 3\n08150 Parets del Vallès, Barcelona",
      phone_label: "Phone",
      hours_label: "Opening hours",
      hours_weekdays: "Monday to Friday",
      hours_weekend: "Saturday & Sunday",
      hours_closed: "Closed",
      cta_whatsapp: "Chat on WhatsApp",
      cta_call: "Call now",
      cta_directions: "Get directions",
    },
    footer: {
      tagline: "Mechanics · Tuning · Diagnostics",
      company_label: "Company",
      activity_label: "Activity",
      activity: "Motor vehicle maintenance and repair",
      rights: "All rights reserved.",
    },
  },
};

export const WHATSAPP_NUMBER = "34653043214";
export const PHONE_DISPLAY = "+34 931 57 07 90";
export const PHONE_TEL = "+34931570790";
export const MAPS_URL =
  "https://www.google.com/maps/dir/?api=1&destination=Cami+de+Can+Guasch+5+Nave+3+08150+Parets+del+Vall%C3%A8s";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
